import { translatedMessage } from "../service/LanguageService";

const CompetitionUtils = {

  isNationalCompetition(_type) {
    return _type === 'NATIONAL_DEBUTANT' || _type === 'NATIONAL_HIGH' || _type === 'NATIONAL_PROMOVARE_ONLINE' || _type === 'NATIONAL_PROMOVARE_OFFLINE'
  },

  isPromovareCompetition(_type) {
    return _type === 'NATIONAL_PROMOVARE_ONLINE' || _type === 'NATIONAL_PROMOVARE_OFFLINE'
  },

  isJobCompetition(_type) {
    return _type === 'JOB_HIGH' || _type === 'JOB_DEBUTANT'
  },

  isDebutantCompetition(_type) {
    return _type === 'NATIONAL_DEBUTANT' || _type === 'JOB_DEBUTANT'
  },

  isHighCompetition(_type) {
    return _type === 'NATIONAL_HIGH' || _type === 'JOB_HIGH'
  },

  isOfflineCompetition(_type) {
    return _type === 'NATIONAL_PROMOVARE_OFFLINE'
  },

  isPromovareOnlineCompetition(_type) {
    return _type === 'NATIONAL_PROMOVARE_ONLINE'
  },

  getLegalBasisByPositionCategory(_positionCategory) {
    if (_positionCategory === "FUNCTII_PUBLICE_DE_CONDUCERE" || _positionCategory === "FUNCTII_PUBLICE_DE_EXECUTIE") {
      return "REC"
    } else if (_positionCategory === "FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE") {
      return "PROM"
    } else if (_positionCategory === "FUNCTII_PUBLICE_DE_EXECUTIE_TEMP") {
      return "REC_VAC"
    } else if (_positionCategory === "INALTI_FUNCTIONARI_PUBLICI") {
      return "IFP"
    } else {
      return null
    }
  },

  getExamNameByType(_exam) {
    if (_exam?.examType === "SUPPLEMENTARY_EXAM") {
      return _exam.examName
    } else {
      return translatedMessage("CompetitionExamType." + _exam.examType)
    }
  },

  canEdit(competition) {
    if (competition?.status === 'DRAFT') {
      return true;
    }

    return false;
  },

  canEditCalendar(competition) {
    if (competition?.status === 'DRAFT') {
      return true;
    }

    return false;
  },

  canValidate(competition) {
    if (competition?.status === 'DRAFT') {
      return true;
    }

    return false;
  },

  canChangeFiles(competition, usageCode = null) {
    if (competition?.status === 'VALIDATED' && usageCode === 'NomFileUsageCompetitionJobNotification') {
      return true;
    }

    return false;
  },

  canMoveToDraft(competition) {
    if (competition?.status === 'VALIDATED' || competition?.status === 'RETIRED' || competition?.status === 'REJECTED') {
      return true;
    }

    return false;
  },

  canRetire(competition) {
    if (competition?.status === 'SENT' || competition?.status === 'APPROVED') {
      return true;
    }

    return false;
  },

  canApproveReject(competition) {
    if (competition?.status === 'SENT') {
      return true;
    }

    return false;
  },

  getConfirmMessageForAction(action) {
    switch (action) {
      case 'VALIDATE':
        return (
          {
            message:
              <div>
                <div className='mb-2 font-bold'>{translatedMessage('competition.job.confirm.validate')}</div>
                <div className='mb-2'>{translatedMessage('competition.job.confirm.validate.info')}</div>
              </div>,
            header: translatedMessage('competition.job.validate.title'),
            acceptClassName: 'p-button p-button-primary',
            acceptIcon: 'pi pi-file-pdf',
            rejectClassName: 'p-button-text',
            rejectIcon: 'pi pi-times',
            className: 'pcn-confirm-dialog icon-warning',
            icon: "pi pi-exclamation-triangle",
            rejectLabel: translatedMessage("generic.cancel"),
            acceptLabel: translatedMessage("generic.generatePDF"),
          }
        );
      case 'UNLOCK':
        return (
          {
            message:
              <div>
                <div className='mb-2 font-bold'>{translatedMessage('competition.confirm.editable')}</div>
                <div className='mb-2'>{translatedMessage('competition.confirm.editable.info')}</div>
              </div>,
            header: translatedMessage('competition.edit'),
            acceptClassName: 'p-button p-button-primary',
            acceptIcon: 'pi pi-check',
            rejectClassName: 'p-button-text',
            rejectIcon: 'pi pi-times',
            className: 'pcn-confirm-dialog icon-warning',
            icon: "pi pi-exclamation-triangle",
            rejectLabel: translatedMessage("generic.cancel"),
            acceptLabel: translatedMessage("generic.edit"),
          }
        );
      case 'RETIRE':
        return (
          {
            message:
              <div>
                <div className='mb-2 font-bold'>{translatedMessage('competition.confirm.retire')}</div>
                <div className='mb-2'>{translatedMessage('competition.confirm.retire.info')}</div>
              </div>,
            header: translatedMessage('competition.retire'),
            acceptClassName: 'p-button p-button-warning',
            acceptIcon: 'pi pi-check',
            rejectClassName: 'p-button-text',
            rejectIcon: 'pi pi-times',
            className: 'pcn-confirm-dialog icon-warning',
            icon: "pi pi-exclamation-triangle",
            rejectLabel: translatedMessage("generic.cancel"),
            acceptLabel: translatedMessage("competition.retire"),
          }
        );
      case 'APPROVE':
        return (
          {
            message:
              <div>
                <div className='mb-2 font-bold'>{translatedMessage('competition.confirm.approve')}</div>
              </div>,
            header: translatedMessage('competition.approve'),
            acceptClassName: 'p-button p-button-primary',
            acceptIcon: 'pi pi-check',
            rejectClassName: 'p-button-text',
            rejectIcon: 'pi pi-times',
            className: 'pcn-confirm-dialog icon-warning',
            icon: "pi pi-exclamation-triangle",
            rejectLabel: translatedMessage("generic.cancel"),
            acceptLabel: translatedMessage("competition.approve"),
          }
        );
      case 'REJECT':
        return (
          {
            message:
              <div>
                <div className='mb-2 font-bold'>{translatedMessage('competition.confirm.reject')}</div>
              </div>,
            header: translatedMessage('competition.approve'),
            acceptClassName: 'p-button p-button-danger',
            acceptIcon: 'pi pi-check',
            rejectClassName: 'p-button-text',
            rejectIcon: 'pi pi-times',
            className: 'pcn-confirm-dialog icon-warning',
            icon: "pi pi-exclamation-triangle",
            rejectLabel: translatedMessage("generic.cancel"),
            acceptLabel: translatedMessage("competition.approve"),
          }
        );
      case 'FINALIZE':
        return (
          {
            message:
              <div>
                <div className='mb-2 font-bold'>{translatedMessage('competition.confirm.finalize_no_applications')}</div>
              </div>,
            header: translatedMessage('competition.finalize_no_applications'),
            acceptClassName: 'p-button p-button-warning',
            acceptIcon: 'pi pi-check',
            rejectClassName: 'p-button-text',
            rejectIcon: 'pi pi-times',
            className: 'pcn-confirm-dialog icon-warning',
            icon: "pi pi-exclamation-triangle",
            rejectLabel: translatedMessage("generic.cancel"),
            acceptLabel: translatedMessage("competition.finalize_no_applications"),
          }
        );
      default:
        return "";
    }
  },

  getSuccessMessageForAction(action) {
    switch (action) {
      case 'VALIDATE':
        return translatedMessage('competition.validation.success')
      case 'UNLOCK':
        return translatedMessage('competition.editable.success')
      case 'RETIRE':
        return translatedMessage('competition.retire.success')
      case 'APPROVE':
        return translatedMessage('competition.approve.success')
      case 'REJECT':
        return translatedMessage('competition.reject.success')
      case 'CANCEL':
        return translatedMessage('competition.cancel.success')
      case 'FINALIZE':
        return translatedMessage('competition.finalize_no_applications.success')
      default:
        return "";
    }
  },

  getAcceptButtonLabelForAction(action) {
    switch (action) {
      case 'RETIRE':
        return translatedMessage('competition.retire')
      case 'REJECT':
        return translatedMessage('competition.reject')
      case 'CANCEL':
        return translatedMessage('competition.cancel')
      default:
        return "";
    }
  },

  getDialogTitleForAction(action) {
    switch (action) {
      case 'RETIRE':
        return translatedMessage('competition.confirm.retire')
      case 'REJECT':
        return translatedMessage('competition.confirm.reject')
      case 'CANCEL':
        return translatedMessage('competition.confirm.cancel')
      default:
        return "";
    }
  },

  getDialogInfoForAction(action) {
    switch (action) {
      case 'RETIRE':
        return translatedMessage('competition.confirm.retire.info')
      default:
        return "";
    }
  },

  getCompetitionStatus(competition) {
    let status = translatedMessage('CompetitionStatus.' + competition?.status);

    if (competition?.type === "NATIONAL_PROMOVARE_ONLINE" && competition?.status === 'PRELIMINARY_TEST' &&
      competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      status = translatedMessage('CompetitionStatus.' + competition?.type + "." + competition?.status);
    }

    if (competition?.type === "NATIONAL_PROMOVARE_OFFLINE" && competition?.status === 'ADVANCED_TEST' &&
      competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      status = translatedMessage('CompetitionStatus.' + competition?.type + "." + competition?.status);
    }

    return status;
  },

  getCompetitionStatusCode(competition) {
    let status = competition?.status

    if (competition?.type === "NATIONAL_PROMOVARE_ONLINE" && competition?.status === 'PRELIMINARY_TEST' &&
      competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      status = competition?.status + ".PROMOVARE_ONLINE"
    }

    if (competition?.type === "NATIONAL_PROMOVARE_OFFLINE" && competition?.status === 'ADVANCED_TEST' &&
      competition?.positionCategory === 'FUNCTII_PUBLICE_DE_CONDUCERE_PROMOVARE') {
      status = competition?.status + ".PROMOVARE_OFFLINE"
    }

    return status;
  },

};

export default CompetitionUtils;